import React from 'react';
import Button from '../CustomButtons/Button.js';
import { makeStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import styles from '../../assets/jss/material-kit-react/views/componentsSections/basicsStyle.js';

const useStyles = makeStyles(styles);

const AddButton = props => {
  const classes = useStyles();
  const { ...rest } = props;

  return (
    <Button
      onClick={props.onClick}
      justIcon
      round
      color='primary'
      size='lg'
      {...rest}
    >
      <AddIcon className={classes.icons} />
    </Button>
  );
};

export default AddButton;
